import Generator from '../../../Generator'
import Types from '../../../../actions/Types'

export default Generator.node({
  baseType: Types.OWNERS,
  nodeType: Generator.NODETYPE.GET
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/owners/get.js